
export function get (params) {
  const keys = Object.keys(params)
  let queryString = ''
  keys.forEach((param, index) => {
    queryString += index !== keys.length - 1 ? `${param}=${params[param]}&` : `${param}=${params[param]}`
  })
  return queryString
}

export const bankCodeHandler = (rawList, locale) => {
  const bankCode = rawList.map(item => {
    const { bankCode, memo, ...rest } = item
    const memoParse = JSON.parse(memo)
    const label = memoParse[locale]
    const returnObject = { bankCode, label, ...rest }
    return returnObject
  })
  return bankCode
}

export const payTypeHandler = (rawList, locale) => {
  const payType = rawList.map(item => {
    const memo = JSON.parse(item.memo)
    const label = memo[locale]
    const returnObject = { payType: item.payType, label, runnerStatus: item.runnerStatus }
    return returnObject
  })
  return payType
}

// ! 完全切割物件記憶體位置複製方法
export const copyObjectDeep = (object) => {
  const objectTemp = object.length !== undefined ? [] : {}
  Object.keys(object).forEach(key => {
    if (typeof object[key] === 'string' || typeof object[key] === 'number' || typeof object[key] === 'boolean') {
      objectTemp[key] = object[key]
    } else {
      objectTemp[key] = copyObjectDeep(object[key])
    }
  })
  return objectTemp
}
// ! 完全切割物件記憶體位置複製方法
